// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1l-Es","addWidgetButton":"Header_addWidgetButton__3orYI","dashboardTabs":"Header_dashboardTabs__2IsLI","active":"Header_active__393J5"};